import { render } from "./CareerApplicant.vue?vue&type=template&id=b4b0e760&scoped=true"
import script from "../js/career-applicant.js?vue&type=script&lang=js"
export * from "../js/career-applicant.js?vue&type=script&lang=js"

import "./CareerApplicant.vue?vue&type=style&index=0&id=b4b0e760&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b0e760"]])

export default __exports__